import Dashboard from './Dashboard/Dashboard';
import Search from './Search/Search';
import {
  PropertySearch,
  TaxMaps,
  RecentReports,
  DepOnline,
  Bankruptcy,
  XosImages,
  Preacris,
  License,
  UserManual,
  UserUsageReport,
  TaxTrax,
} from 'pages';

export default {
  dashboard: {
    index: -1,
    link: 'dashboard',
    header: '',
    icon: 'dashboard',
    text: 'Dashboard',
    component: Dashboard,
    visible: true,
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  nycDataBase: {
    index: 0,
    link: 'nyc-online-abstract',
    header: 'NYC Online Abstract',
    icon: 'database',
    text: 'NYC Online Abstract',
    component: Search,
    visible: true,
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  propertySearch: {
    index: 1,
    link: 'property-look-up',
    header: 'Property Look Up',
    icon: 'search',
    text: 'Property Look Up',
    component: PropertySearch,
    visible: true,
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  taxMaps: {
    index: 2,
    link: 'tax-maps',
    header: 'Tax Maps',
    icon: 'environment',
    text: 'Tax Maps',
    component: TaxMaps,
    visible: true,
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  depOnline: {
    index: 3,
    link: 'dep-online',
    header: 'NYC DEP Online',
    icon: 'home',
    text: 'NYC DEP Online',
    component: DepOnline,
    visible: true,
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  bankruptcy: {
    index: 4,
    link: 'bankruptcy',
    header: 'National Name Database',
    icon: 'global',
    text: 'National Name DB',
    component: Bankruptcy,
    visible: true,
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  preacris: {
    index: 5,
    link: 'preacris',
    header: 'DocuTrax',
    icon: 'file',
    text: 'DocuTrax',
    component: Preacris,
    visible: true,
    version: ['Dev', 'Dev', 'Prod', 'Staging'],
  },
  taxTrax: {
    index: 6,
    link: 'taxtrax',
    header: 'TaxTrax',
    icon: 'dollar',
    text: 'TaxTrax',
    component: TaxTrax,
    visible: true,
    version: ['Dev', 'Dev', 'Prod', 'Staging'],
  },
  /*xosImages: {
    index: 5,
    link: 'xosimages',
    header: 'Document Images',
    icon: 'file',
    text: 'Document Images',
    component:XosImages,
    visible: true,
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },*/
  recentReports: {
    index: 7,
    link: 'recent-reports',
    header: 'Recent Reports',
    icon: 'file-search',
    text: 'Recent Reports',
    component: RecentReports,
    visible: true,
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  userUsageReport: {
    index: 8,
    link: 'usage-report',
    header: 'Usage Report',
    icon: 'team',
    text: 'Usage Report',
    component: UserUsageReport,
    visible: true,
    version: ['Test', 'Dev', 'Prod', 'Staging'],
    requiresBillingInfoAccess: true,
  },
  license: {
    index: 9,
    link: 'license',
    header: 'license',
    icon: 'file-search',
    text: 'License Aagreement',
    component: License,
    visible: false,
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  userManual: {
    index: 10,
    link: 'user-manual',
    header: 'User Manual',
    icon: 'question-circle',
    text: 'User Manual',
    component: UserManual,
    visible: true,
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
};
